import { Input } from 'antd';
import { FC } from 'react';

export const InputSearch: FC<{isMobile:boolean}> = (props) => {

    const _styleInput:React.CSSProperties = { 
        width: "calc(100% - 20px);",
        height: "44px",
        borderRadius: "8px",
        border: !props.isMobile ?  "1px solid #848484" : "",
        paddingBottom:!props.isMobile ? "0px" : "20px"
    }
    return (
        <Input  bordered={!props.isMobile} style={_styleInput}
            size="large" placeholder="¿Que auto buscas?" suffix={
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.7774 20.6769L27.7727 26.6723C28.0764 26.976 28.0764 27.4685 27.7727 27.7722C27.4689 28.0759 26.9765 28.0759 26.6727 27.7722L20.6774 21.7769C18.4835 23.7137 15.6015 24.8889 12.4449 24.8889C5.57206 24.8889 0.000488281 19.3173 0.000488281 12.4444C0.000488281 5.57157 5.57206 0 12.4449 0C19.3178 0 24.8894 5.57157 24.8894 12.4444C24.8894 15.601 23.7141 18.4831 21.7774 20.6769ZM12.4449 23.3333C18.4587 23.3333 23.3338 18.4582 23.3338 12.4444C23.3338 6.43068 18.4587 1.55556 12.4449 1.55556C6.43117 1.55556 1.55604 6.43068 1.55604 12.4444C1.55604 18.4582 6.43117 23.3333 12.4449 23.3333Z" fill="#002570" />
                </svg>
            }></Input>
    )
}